<template>
    <div>
        <div v-for="(item, index) in artefactsList" :key="index">
            <div class="row">
                <div class="col-sm-8">
                    <artefact-select
                        :selected-artefact-type="item.artefactType"
                        :selected-artefact="item.artefact"
                        :create-hidden-input="createHiddenInput"
                        :artefact-type-input-name="`${artefactTypeInputName}[]`"
                        :artefact-input-name="`${artefactInputName}[]`"
                        @update-artefact="updateArtefact"
                        :index="index"
                    ></artefact-select>
                </div>
                <div class="col-sm-1 pull-center">
                    <span class="btn btn-fill btn-github" @click="remove(index)"
                        >Kaldır&nbsp;<i class="fa fa-times-circle"></i
                    ></span>
                </div>
            </div>
        </div>

        <p class="btn btn-fill btn-twitter" @click="add">
            Ekle
        </p>
    </div>
</template>
<script type="javascript">

import artefactSelect from './artefact-select.vue'

export default {
    name: 'ArtefactSelectList',
    props: ['selectedArtefacts', 'artefactTypeInputName', 'artefactInputName', 'createHiddenInput'],
    components: {
        artefactSelect
    },
    data() {
        return {
            artefactsList:[]
        }
    },
    methods: {
        add(){
            this.artefactsList.push(
                {
                    artefactType: null,
                    artefact: null,
                }
            )
        },
        remove(index){
            this.artefactsList.splice(index, 1);
            this.$emit('update-artefacts', this.artefactsList)
        },
        updateArtefact(option, index){
            this.artefactsList[index] = {
                artefactType: option.artefactType,
                artefact :{
                    _id: option.artefact._id,
                    title: option.artefact.title
                }
            }
            let nullFilteredList = this.artefactsList.filter((f) => {
                return f.artefact != null
            })

            this.$emit('update-artefacts', nullFilteredList)
        },
    },
    mounted(){
        if(this.selectedArtefacts){
            this.selectedArtefacts.forEach((selected) => {
                this.artefactsList.push(
                    {
                        artefactType: selected.artefactType,
                        artefact: {
                            title: selected.artefact.title,
                            _id: selected.artefact._id,
                        }
                    }
                )
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/vue/artefact-select-list.vue